import { useMutation, useQueryClient } from '@tanstack/react-query';
import { terminologyApi } from '../api/terminologyApi';

/**
 * DELETE /api/eraf/terminology/standard-terms/:id?mode=DEPRECATE
 * On success: invalidates list + summary + detail queries.
 */
export function useDeleteStandardTerm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, mode }: { id: number; mode?: 'DEPRECATE' | 'SOFT_DELETE' }) =>
      terminologyApi.deleteStandardTerm(id, mode ?? 'DEPRECATE'),
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'standard-terms', 'list'],
      });
      void queryClient.invalidateQueries({
        queryKey: ['terminology', 'standard-terms', 'detail', variables.id],
      });
      void queryClient.invalidateQueries({ queryKey: ['terminology', 'summary'] });
    },
  });
}
